import { getDefaultExportFromCjs as U } from "../../../../../../../_virtual/_commonjsHelpers.js";
import { l as S } from "../../../../../lodash.toarray@4.4.0/bundled_deps/lodash.toarray/index.js";
import { f as I } from "./flatten.js";
import { f as F } from "./for_each_object.js";
import { i as O } from "./includes.js";
import { m as _ } from "./map_object.js";
import { f as b } from "./filter_object.js";
import { v as x } from "./values.js";
import { u as C } from "./unique.js";
import { i as y } from "./is_undefined.js";
import T from "./emoji.json.js";
var D = S, N = I, A = F, p = O, h = _, k = b, v = x, E = C, s = y, B = function(i) {
  for (var e = [], t = 0, n = i.length, r, o, d, l; t < n; )
    d = i.charAt(t), r = i.charCodeAt(t++), r >= 55296 && r <= 56319 && t < n ? (l = i.charAt(t), o = i.charCodeAt(t++), (o & 64512) == 56320 ? e.push([d + l, ((r & 1023) << 10) + (o & 1023) + 65536]) : (e.push([d, r]), t--)) : e.push([d, r]);
  return e;
}, c = "__ic_", g = T, u = {};
g.forEach(function(i, e) {
  i.forEach(function(t) {
    u[t.unicode] = {
      identifier: t.identifier,
      isEmojiBase: t.isEmojiBase,
      supportedTwemoji: t.supportedTwemoji,
      categoryIndex: e
    };
  });
});
var a = {
  ":-)": "😀",
  ":-D": "😃",
  ";-)": "😉",
  "}-)": "👿",
  ":-o": "😮",
  ":-O": "😮",
  ":-/": "😕",
  ":-\\": "😕",
  "x-(": "😩",
  "X-(": "😩",
  ":-(": "😞",
  "B-)": "😎",
  ":-p": "😛",
  ":-P": "😛",
  ":-@": "😠",
  ":-|": "😐",
  ":-$": "😳"
};
A(a, function(i, e) {
  u[i][c + "ascii"] = e;
});
var f = [
  /* Following rendered poorly by Chrome 41.0.2272.118 */
  "⁉",
  "⁉️",
  "‼️",
  "✂",
  "✈",
  "✉",
  "❤",
  "✌",
  "✏",
  "⚠",
  "🈷",
  "🈂",
  "Ⓜ",
  "Ⓜ️",
  "✒",
  "✔",
  "✖",
  "◼",
  "◻",
  "™",
  "☀",
  "☁",
  "♠",
  "♠️",
  "♣",
  "♣️",
  "♥",
  "♥️",
  "♦",
  "♦️",
  "♨",
  "▪",
  "▫",
  "ℹ",
  "↔",
  "↔️",
  "↕",
  "↖",
  "↖️",
  "↗",
  "↗️",
  "↘",
  "↘️",
  "↙",
  "↙️",
  "☑",
  "〰",
  "♻",
  "〽",
  "▶",
  "▶️",
  "☝",
  "✳",
  "✴",
  "❄",
  "❇",
  "⬆",
  "⬇",
  "⬅",
  "➡",
  "◀",
  "◀️",
  "↩",
  "↪",
  "⤴",
  "⤴️",
  "⤵",
  "⤵️",
  "㊗",
  "㊙",
  "☺",
  "☺️",
  "☹️",
  "☹",
  "‼",
  "🅰",
  "🅰️",
  "🅱",
  "🅱️",
  "🅿",
  "🅿️",
  "🅾",
  "🅾️",
  "🇯",
  "🇰",
  "🇩",
  "🇨",
  "🇺",
  "🇫",
  "🇪",
  "🇮",
  "🇷",
  "🇬",
  /* Following rendered poorly by Firefox 36.0.4 */
  "☔",
  "⭐",
  "⚡",
  "☕",
  "☎",
  "⚓",
  "♈",
  "♉",
  "♐",
  "♑",
  "♒",
  "♓",
  "♿",
  "♊",
  "♋",
  "♌",
  "♍",
  "♎",
  "♏",
  "◾",
  "◽",
  "⚫",
  "⚪"
], m = {};
A(u, function(i, e) {
  m[c + i.identifier] = e;
});
var P = 10, j = g.map(function(i) {
  return i.map(function(e) {
    return e.unicode;
  });
}), w = function(i, e, t) {
  for (var n = [], r = 0, o = 0; r + t <= e.length; ) {
    var d = e.slice(r, r + t);
    i.isSupportedAscii(d) && G(e, r - 1, r + t) ? (o < r && n.push(e.slice(o, r)), n.push(d), r += t, o = r) : ++r;
  }
  return o < e.length && n.push(e.slice(o, e.length)), n;
}, G = function(i, e, t) {
  var n = !1, r = !1;
  return (e < 0 || /\s/.test(i.charAt(e))) && (n = !0), (t >= i.length || /\s/.test(i.charAt(t))) && (r = !0), n && r;
}, L = {
  getGroupRepresentatives: function() {
    return [
      ["😄", "Smileys & Emotion"],
      ["👋", "People & Body"],
      ["🏻", "Component"],
      ["🌸", "Animals & Nature"],
      ["🍇", "Food & Drink"],
      ["🌍", "Travel & Places"],
      ["🎈", "Activities"],
      ["🔔", "Objects"],
      ["🔠", "Symbols"],
      ["🇮🇪", "Flags"]
    ];
  },
  getUglyNativeEmoji: function() {
    return f.slice();
  },
  isUglyNativeEmoji: function(i) {
    return p(f, i);
  },
  hasNativeSupport: function(i) {
    var e, t = "😀";
    if (!i.createElement("canvas").getContext || (e = i.createElement("canvas").getContext("2d"), typeof e.fillText != "function"))
      return !1;
    e.textBaseline = "top", e.font = "32px Arial", e.fillText(t, 0, 0);
    var n = e.getImageData(16, 16, 1, 1);
    return n ? n.data[0] !== 0 : !1;
  },
  isSupportedUnicode: function(i) {
    return u.hasOwnProperty(i);
  },
  isEmojiBaseUnicode: function(i) {
    return u[i].isEmojiBase;
  },
  identifierFromUnicode: function(i) {
    return u[i].identifier;
  },
  asciiFromUnicode: function(i) {
    return u[i][c + "ascii"];
  },
  groupFromUnicode: function(i) {
    return u[i].categoryIndex;
  },
  isSupportedAscii: function(i) {
    return a.hasOwnProperty(i);
  },
  unicodeFromAscii: function(i) {
    return a[i];
  },
  isSupportedIdentifier: function(i) {
    return m.hasOwnProperty(c + i);
  },
  unicodeFromIdentifier: function(i) {
    return m[c + i];
  },
  N_GROUPS: P,
  prettyEmoticonsUnicodeGroups: function() {
    return j.map(function(i) {
      return i.filter(function(e) {
        if (!p(f, e))
          return e;
      });
    });
  },
  allEmoticonsUnicodeGroups: j,
  allEmoticonsUnicodeList: Object.keys(u),
  allEmoticonsIdentifierList: h(u, function(i, e) {
    return i.identifier;
  }),
  prettyEmoticonsIdentifierList: function() {
    return h(
      k(
        u,
        function(i, e) {
          return !p(f, e) && i.isEmojiBase;
        }
      ),
      function(i, e) {
        return i.identifier;
      }
    );
  },
  asciiEmoticonsUnicodeList: E(v(a)),
  asciiEmoticonsIdentifierList: E(v(a)).map(function(i) {
    return u[i].identifier;
  }),
  MIN_ASCII_LENGTH: 3,
  MAX_ASCII_LENGTH: 3,
  // To allow for speed up splitOnAsciiEmojis
  asciiEmoticonsAsciiList: Object.keys(a),
  splitOnUnicodeEmojis: function(i) {
    if (s(i))
      return [];
    var e = D(i), t = [], n = !0;
    return e.forEach((function(r) {
      if (this.isSupportedUnicode(r))
        t.push(r), n = !0;
      else {
        if (n)
          t.push(r);
        else {
          var o = t.pop();
          t.push(o + r);
        }
        n = !1;
      }
    }).bind(this)), t;
  },
  splitOnAsciiEmojis: function(i) {
    if (s(i))
      return [];
    for (var e = [i], t = this.MAX_ASCII_LENGTH; t >= this.MIN_ASCII_LENGTH; --t) {
      for (var n = [], r = 0; r < e.length; ++r)
        n = n.concat(w(this, e[r], t));
      e = n;
    }
    return e;
  },
  getAllModifiedForBaseEmoji: function(i) {
    var e = [];
    if (i === "") return e;
    for (var t in u)
      t.indexOf(i) > -1 && e.push(t);
    return e;
  },
  splitOnUnicodeAndAsciiEmojis: function(i) {
    return s(i) ? [] : N(
      this.splitOnUnicodeEmojis(i).map((function(e) {
        return this.splitOnAsciiEmojis(e);
      }).bind(this))
    );
  },
  substituteUnicodeForAsciiEmojis: function(i) {
    return s(i) || i === null ? "" : this.splitOnAsciiEmojis(i).map((function(e) {
      return this.isSupportedAscii(e) ? this.unicodeFromAscii(e) : e;
    }).bind(this)).reduce(function(e, t) {
      return e + t;
    }, "");
  },
  wrapUnicodeEmojiInTitledSpans: function(i, e, t, n) {
    return s(e) ? "" : this.splitOnUnicodeEmojis(e).map((function(r) {
      if (this.isSupportedUnicode(r)) {
        if (this.isUglyNativeEmoji(r))
          return this.fallbackImage(i, r, t);
        var o = "";
        return n && (o = ' role="img" aria-label="' + this.identifierFromUnicode(r) + '"'), '<span title="' + this.identifierFromUnicode(r) + '"' + o + ">" + r + "</span>";
      } else
        return r;
    }).bind(this)).reduce(function(r, o) {
      return r + o;
    }, "");
  },
  substituteUnicodeForColonified: function(i) {
    for (var e = function(d) {
      return ":" + d + ":";
    }, t = !0, n = "", r = "", o = 0; o < i.length; o++)
      i[o] === ":" ? (t ? (t = !1, r += n) : (t = !0, r += this.isSupportedIdentifier(n) ? this.unicodeFromIdentifier(n) : e(n)), n = "") : n += i[o];
    return t || (r += ":"), r += n;
  },
  codepointIndexFromUnicode: function(i) {
    return B(i).map(function(e) {
      return e[1];
    });
  },
  fallbackImage: function(i, e, t) {
    return s(e) ? "" : this.splitOnUnicodeAndAsciiEmojis(e).map((function(n) {
      return this.isSupportedAscii(n) ? this.twemojiSpanTag(i, this.unicodeFromAscii(n), t) : this.isSupportedUnicode(n) ? this.twemojiSpanTag(i, n, t) : n;
    }).bind(this)).join("");
  },
  twemojiStyleString: function(i, e) {
    return "display:inline-block;height:" + i + "px;width:" + i + "px;background-image:url(" + this.twemojiSVGUri(e) + ");background-size:contain;";
  },
  twemojiSpanTag: function(i, e, t) {
    return s(t) && (t = "intermoji-default-class"), '<span style="' + this.twemojiStyleString(i, e) + '" title="' + this.identifierFromUnicode(e) + '" class="' + t + '" role="img" aria-label="' + this.identifierFromUnicode(e) + '"></span>';
  },
  twemojiSVGUri: function(i) {
    var e = this.getSupportedTwemoji(i), t = this.codepointIndexFromUnicode(e).map(function(r) {
      return r.toString(16);
    }), n = t.join("-").toLowerCase() + ".svg";
    return "https://js.intercomcdn.com/images/stickers/v2/svg/" + n;
  },
  getSupportedTwemoji: function(i) {
    return i in u && u[i].supportedTwemoji || i;
  },
  getEmojiFromSupportedTwemoji: function(i) {
    return Object.keys(u).find(function(e) {
      return u[e].supportedTwemoji === i;
    }) || i;
  }
};
const Y = /* @__PURE__ */ U(L);
export {
  Y as default
};
